import config from '../../config'
import fetcher, { formDataFetcher } from '../fetcher'
import { CVRoasterResult } from './types'

export const uploadAndAnalyzeCV = async (_: string, { arg }: { arg: { file: File } }): Promise<CVRoasterResult> => {
  try {
    const formData = new FormData()
    formData.append('cv', arg.file)

    // Use the formDataFetcher for file uploads - endpoint is gpt/cv-roaster
    const result = await formDataFetcher(
      `${config.VITE_ZRIVE_API_URL}/api/gpt/cv-roaster`,
      formData
    )

    return result
  } catch (error) {
    console.error('Error uploading and analyzing CV:', error)
    throw error
  }
}

export const uploadAndAnalyzeCVForJobOffer = async (_: string, { arg }: { arg: { file: File | null, jobOfferId: number} }): Promise<CVRoasterResult> => {
  try {
    const formData = new FormData()
    if(arg.file) {
      formData.append('cv', arg.file)
    }

    // Use the formDataFetcher for file uploads - endpoint is gpt/cv-roaster
    const result = await formDataFetcher(
      `${config.VITE_ZRIVE_API_URL}/api/gpt/cv-matching/job-offer/${arg.jobOfferId}`,
      formData
    )

    return result
  } catch (error) {
    console.error('Error uploading and analyzing CV:', error)
    throw error
  }
}

export const getCvFeedbackForJobOffer = async (jobOfferId: number): Promise<CVRoasterResult> => {
  try {
    const result = await fetcher(
      `${config.VITE_ZRIVE_API_URL}/api/gpt/cv-matching/job-offer/${jobOfferId}`,
      { method: 'GET' },
    )
    return result
  } catch (error) {
    console.error('Error fetching CV feedback for job offer:', error)
    throw error
  }
}
